<template>
  <div class="box">
    <div class="box-title">
      <img src="../../../assets/app/keyFigures.png" alt="">
      <font>关键指标</font>
    </div>
    <div class="box-tabs">
      <div class="box-tab">
        <div class="box-tab-item">客户</div>
        <div class="box-tab-item" :class="{'box-tab-item-active':active}">存量</div>
        <div class="box-tab-item">收入</div>
        <div class="box-tab-item">4G</div>
        <div class="box-tab-item">宽带</div>
        <div class="box-tab-item">终端</div>
        <div class="box-tab-item">终端</div>
        <div class="box-tab-item">终端</div>
      </div>
      <div class="box-datas">
        <div class="box-datas-item">
          <div class="box-datas-item-div">
            <div class="box-datas-item-div-left">
              <div class="box-datas-item-div-left-title">期末通话客户数</div>
              <div class="box-datas-item-div-left-title-sub">当月累计</div>
            </div>
            <div class="box-datas-item-div-right">66666666（户）</div>
          </div>
        </div>
        <div class="box-datas-item">
          <div class="box-datas-item-div">
            <div class="box-datas-item-div-left">
              <div class="box-datas-item-div-left-title">期末通话客户数</div>
              <div class="box-datas-item-div-left-title-sub">当月累计</div>
            </div>
            <div class="box-datas-item-div-right">66666666（户）</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: true
    }
  },
  props: [],
  watch: {},
  mounted() {},
  methods: {}
}

</script>
<style lang="less" scoped>
@font-color1: #43484D; //标题
@font-color2: #86939E; //一般文字
@font-color3: #0384DF; //蓝色
@font-color4: #FFF; //白色
@font-color5: #31373D; //黑色
.box {
  font-family: "PingFang-SC-Regular";
  overflow: hidden;
}

.box-title {
  color: @font-color1;
  height: 0.84rem;
  line-height: 0.84rem;
  text-align: center;
  font-size: 0.31rem;
  font-family: 'PingFang-SC-Heavy';
  border-bottom: 0.02rem solid #eee;
  img {
    position: relative;
    width: 0.34rem;
    top: 0.05rem;
    margin-right: 0.1rem;
  }
}

.box-tabs {
  color: @font-color2;
  font-size: 0.28rem;
  height: auto;
  line-height: 0.72rem;
  border-bottom: 0.02rem solid #eee;
  text-align: center;
  overflow-x: scroll;
  .box-tab {
    display: flex;
    width: 10rem;
  }
  .box-tab-item {
    flex: 1;
    width: 1.25rem;
  }
  .box-tab-item-active {
    color: @font-color5;
    font-size: 0.28rem;
    font-weight: 700;
    font-family: 'PingFang-SC-Heavy';
  }
}

.box-datas {
  color: #FFF;
  margin-top: 1px;
  .box-datas-item {
    padding: 0.2rem 0.1rem 0.2rem 0.4rem;
    height: 1.34rem;
    background-color: #8E96E8;
    .box-datas-item-div {
      display: flex;
      .box-datas-item-div-left {
        flex: 1;
        text-align: left;
        .box-datas-item-div-left-title {
          font-family: "PingFang-SC-Bold";
          font-weight: 700;
        }
      }
      .box-datas-item-div-right {
        flex: 1;
        font-size: 0.42rem;
        text-align: right;
        padding-top: 0.3rem;
        font-family: "PingFang-SC-Bold";
        font-weight: 700;
      }
    }
  }
  .box-datas-item:last-child {
    background-color: #8EB6E8;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/app/index/keyFigures.vue